module.exports = __webpack_public_path__ + "static/media/Facebook.cabe0a2b.svg";